<dx-data-grid [dataSource]="instancesGrid" [showBorders]="true" [columns]="columns">
  <dxo-filter-row [visible]="true"></dxo-filter-row>
  <div *dxTemplate="let instance of 'instanceName'">
    <div (click)="openWindow(instance.data)" [ngClass]="{ active: instance.data.isActive }">{{ instance.value }}</div>
  </div>
</dx-data-grid>
